import SudoPage from './SudoPage'

export default SudoPage
